import React from 'react';
import ReactDOM from 'react-dom';
import ArticlePageContent from './ArticlePageContent';

if (document.getElementById("articleJson") !== null) {
    var Article = JSON.parse(document.getElementById("articleJson").textContent); // eslint-disable-next-line
    var salonCountries = JSON.parse(document.getElementById("salonCountries").textContent); // eslint-disable-next-line
    var layout = JSON.parse(document.getElementById("Layout").textContent); // eslint-disable-next-line
    var productspage = JSON.parse(document.getElementById("productsPage").textContent); // eslint-disable-next-line
    var language = document.getElementById('divlang').getAttribute('data-id'); // eslint-disable-next-line

    if (document.getElementById("breadcrumbJson") !== null) {
        var breadcrumbs = JSON.parse(document.getElementById("breadcrumbJson").textContent); // eslint-disable-next-line
    }
    ReactDOM.render(<ArticlePageContent lang={language} article={Article} breadcrumbs={breadcrumbs} salonCountries={salonCountries} productspage={productspage} {...layout.Model}  />, document.getElementById('ArticlePageIndex'));
}
